import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { StorageTablesService } from "src/service/storage-tables.service";
import { Widget, Dashboard } from 'src/api/models'
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: "app-chart-widget-editor",
  templateUrl: "./chart-widget-editor.component.html",
  styleUrls: ["./chart-widget-editor.component.css"],
})
export class ChartWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: ChartWidget;
  public dashboard: Dashboard;
  public w: any;


  private colours: string[];

  constructor(public storageTablesService: StorageTablesService, public app: ApplicationConfigService) {
    this.colours = [
      '#2f7ed8', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];
  }

  ngOnInit() {
    this.w = this.widget;
    if (this.w.bandDetailList == null) this.w.bandDetailList = [];
    if (this.w.lineDetailList == null) this.w.lineDetailList = [];
    //if (this.w.dataSourceDetailList == null) this.w.dataSourceDetailList = [];

    let i = 0;
    for (let tab of this.w.timeSeriesDetailList) {
      tab.removable = true;
      if (tab.transforms == null){
        tab.transforms = [];
      }
      if (tab.colour == null){
          tab.colour = this.colours[i]
      }
      i++;
    }
    if (this.w.timeSeriesDetailList.length > 0) {
      this.w.timeSeriesDetailList[0].active = true;
    }
  }

  public addTimeSeries() {
    this.w.timeSeriesDetailList.push({
      uri: "",
      axis: 0,
      type: "line",
      style: "solid",
      showMarker: false,
      markerType: "circle",
      customTooltip : false,
      customTooltipTags: [{metaTag:"", displayName:""}],
      size: 1,
      active: true,
      removable: true,
      colour: this.colours[this.w.timeSeriesDetailList.length],
      transforms: [],
    });
  }

  public removeTimeSeries(timeSeries: any): void {
    const index = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.timeSeriesDetailList.splice(index, 1);
    }
  }

  public addLine() {
    this.w.lineDetailList.push({
      value: 0,
      colour: "#EEE",
      name: "",
      active: true,
      removable: true,
    });
  }

  public removeLine(timeSeries: any): void {
    const index = this.w.lineDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.lineDetailList.splice(index, 1);
    }
  }

  public addBand() {
    this.w.bandDetailList.push({
      min: 0,
      max: 0,
      colour: "#EEE",
      name: "",
      active: true,
      removable: true,
    });
  }

  public removeBand(timeSeries: any): void {
    const index = this.w.bandDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.bandDetailList.splice(index, 1);
    }
  }

  public duplicate(timeSeries: any): void {
    const newEntry = JSON.stringify(timeSeries)
    this.w.timeSeriesDetailList.push(JSON.parse(newEntry));
  }

  public addMetaTag(timeSeries: any){
    const ind = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (ind >-1)
    {
      if (this.w.timeSeriesDetailList[ind].customTooltipTags == null)
      {
        this.w.timeSeriesDetailList[ind]['customTooltipTags'] = [{metaTag:"", displayName:""}];
      }
      else{
        this.w.timeSeriesDetailList[ind].customTooltipTags.push({metaTag:"", displayName:""});    
      }
    }
  }

  public removeMetaTag(timeSeries :any, index: number)
  {
    const ind = this.w.timeSeriesDetailList.indexOf(timeSeries);
    if (ind >-1)
    {
      this.w.timeSeriesDetailList[ind].customTooltipTags.splice(index,1)
    }
    console.log(this.w.timeSeriesDetailList)
  }
  public logChange(tag: any) {
    console.log('Tag changed:', tag);
  }

  public trackByFn(index: number, item: any): number {
    return index; // or item.id if you have a unique identifier
  }
}



